import { Controller } from "stimulus"

/**
 * Assembles individual dial-digit inputs into per-register native values
 * and computes a live meter total across all registers.
 *
 * Each register group has a data-register-id attribute and contains one
 * input[data-digit] per dial position. Digit inputs fire
 * data-action="input->meter-reading#advance" which clamps to 0-9,
 * auto-advances focus, and recomputes the register value and meter total.
 */
export default class extends Controller {
  static targets = ["registerGroup", "registerValue", "meterTotal"]

  connect() {
    this.compute()
  }

  compute() {
    var total = 0
    var groups = this.registerGroupTargets

    for (var i = 0; i < groups.length; i++) {
      var group = groups[i]
      var inputs = group.querySelectorAll("input[data-digit]")
      var assembled = ""

      for (var j = 0; j < inputs.length; j++) {
        var val = inputs[j].value
        assembled += (val.length === 1) ? val : "0"
      }

      var numericValue = parseInt(assembled, 10) || 0
      var valueDisplay = group.querySelector("[data-target='meter-reading.registerValue']")
      if (valueDisplay) {
        valueDisplay.textContent = numericValue.toLocaleString()
      }

      total += numericValue
    }

    for (var k = 0; k < this.meterTotalTargets.length; k++) {
      this.meterTotalTargets[k].textContent = total.toLocaleString()
    }
  }

  /**
   * Auto-advances focus to the next digit input after entry.
   */
  advance(event) {
    var input = event.target
    // Clamp to single digit 0-9
    var val = input.value.replace(/[^0-9]/g, "")
    if (val.length > 1) val = val.charAt(val.length - 1)
    input.value = val

    this.compute()

    // Auto-advance to next digit input
    if (val.length === 1) {
      var allDigits = this.element.querySelectorAll("input[data-digit]")
      for (var i = 0; i < allDigits.length; i++) {
        if (allDigits[i] === input && i < allDigits.length - 1) {
          allDigits[i + 1].focus()
          allDigits[i + 1].select()
          break
        }
      }
    }
  }
}
